
import { cn } from "@/lib/utils";

const statusConfig = {
  active: {
    color: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    label: "Active",
    dotColor: "bg-emerald-500"
  },
  inactive: {
    color: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
    label: "Inactive",
    dotColor: "bg-rose-500"
  },
  pending: {
    color: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    label: "Pending",
    dotColor: "bg-amber-500"
  },
  scheduled: {
    color: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    label: "Scheduled",
    dotColor: "bg-blue-500"
  },
  unenrolled: {
    color: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
    label: "Unenrolled",
    dotColor: "bg-rose-500"
  }
};

const StatusBadge = ({ status }: { status: string }) => {
  // Normalize status to lowercase and check if it exists in our config
  const normalizedStatus = status.toLowerCase();
  const statusKey = Object.keys(statusConfig).find(key => 
    key === normalizedStatus
  ) as keyof typeof statusConfig || 'inactive';
  
  const config = statusConfig[statusKey];

  return (
    <span className={cn(
      "px-3 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1.5",
      config.color
    )}>
      <span className={`h-1.5 w-1.5 rounded-full ${config.dotColor}`}></span>
      {config.label}
    </span>
  );
};

export default StatusBadge;
